module.exports = __webpack_public_path__ + "static/site-d36c2f985abd0524f84838e18cdc685d.svg";